import {Component} from "@angular/core";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {WelcomeApiService} from "../../../core/api/welcome-api.service";
import {MessageHelper} from "../../../core/helper/message-helper";
import {AppMessageService} from "../../../core/service/app-message.service";
import {SettingsService} from "../../service/settings.service";


@Component({
  selector: 'agb-info',
  templateUrl: './agb-info.component.html',
  styleUrls: ['./agb-info.component.css']
})
export class AgbInfoComponent extends CoreComponent {

  agbInfo: string | undefined;

  constructor(
    protected settingService: SettingsService,
    protected router: Router,
    protected welcomeApiService: WelcomeApiService,
    protected messageService: AppMessageService,
    protected formBuilder: FormBuilder,) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.settingService.setHeader('AGB', 'Das Kleingedruckte verständlich gemacht.');
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.getAgbInfo();
    this.refreshComponent();
  }

  getAgbInfo() {
    this.welcomeApiService.getAgb().subscribe(res => {
      // this.agbInfo = res;
      this.agbInfo = res.replace(/&nbsp;/g, ' ');
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);

    })
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }


}
